import axios from "axios";
import store from "../redux/store/Store";
import { ILoginResponseNormalized } from "../interfaces/Index";
import { loginSuccess } from "../redux/actions/AuthActions";
import { refreshAccessToken, refreshAccessTokenOIDC } from "../redux/sources/AuthSource";
import { removeFromLocal, getFromLocal } from "../utils/Cache";
const axiosInterceptorInstance = axios.create();

// Request interceptor
axiosInterceptorInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor
axiosInterceptorInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // Push to login and clear storage if refresh call fails
    if (
      error.response.status !== 200 &&
      originalRequest.url.includes("token/renew")
    ) {
      removeFromLocal("auth");
      window.location.reload();
      return Promise.reject(error);
    }

    // If token expired and API returns 401
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken: ILoginResponseNormalized = getFromLocal("auth");
      if (!refreshToken) return Promise.reject(error);
  

      let loginResponse: ILoginResponseNormalized;
      if(refreshToken.isOIDC) {
        const realm = process.env.REACT_APP_KEYCLOAK_IDENTITY_RELM!;
        const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID!;
        loginResponse = await refreshAccessTokenOIDC({
          clientId: clientId,
          refreshToken: refreshToken.auth.refreshToken as string,
          bazaarClientName: "Commando"
        });
      } else {
        loginResponse= await refreshAccessToken({
          username: refreshToken.userInfo.phoneNumber,
          token: refreshToken.auth.refreshToken as string,
        });
      }
     
      store.dispatch(loginSuccess(loginResponse));
      originalRequest.headers.Authorization = `Bearer ${loginResponse.auth.token}`;
      return axiosInterceptorInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default axiosInterceptorInstance;
